export default __webpack_public_path__ + "static/media/scientist.b2aff2c9.svg";